import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "installAllStores", "xlsFile", "xlsFileHidden", "xlsFileDiv" ]

  connect() {
  }

  installAllStoresToggled(event) {
    if ($(this.installAllStoresTarget).is(":checked")) {
      $(this.xlsFileDivTarget).addClass("d-none")
    } else {
      $(this.xlsFileDivTarget).removeClass("d-none")
    }
  }

  submit(event) {
    if ($(this.installAllStoresTarget).is(":checked")) {
      $(this.xlsFileTarget).val("")
      $(this.xlsFileHiddenTarget).val("")
    }
  }
}
